import { CalendarDate } from '@newfront-insurance/string-formatters';
import type { JSX } from 'react';

import CalendarHeader from './components/header';
import CalendarMonth from './components/month';
import { useCalendar } from './hooks/calendar';

interface Props {
  onChange: (date?: CalendarDate) => unknown;
  value?: CalendarDate;
  validate?: (date: CalendarDate) => boolean;
  maxDate?: CalendarDate;
  minDate?: CalendarDate;
}

export function CalendarDatePicker(props: Props): JSX.Element {
  const { onChange, value, validate, maxDate, minDate } = props;
  const maxYear = maxDate?.getYear();
  const minYear = minDate?.getYear();
  const today = CalendarDate.today();

  const calendar = useCalendar({
    initialVisibleMonth: value ? value.getMonth() : today.getMonth(),
    initialVisibleYear: value ? value.getYear() : today.getYear(),
  });

  return (
    <div className="w-[224px]">
      <div className="pb-2">
        <CalendarHeader calendarHook={calendar} minYear={minYear} maxYear={maxYear} />
      </div>
      <CalendarMonth calendarHook={calendar} onClick={onChange} validate={validate} selectedDate={value} />
    </div>
  );
}
